// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-avenue -> repli-training-avenue -> the-avenue-5196
// Generated: 2026-09-11T19:13:52.990Z
// Counts: 1 design, 14 content, 10 slot group, 0 collection binding, 2 section, 0 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.bedroom_list_type": {
    "overrideType": "VALUE",
    "customValue": "derived",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_full_address"
  },
  "footer.copyright": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_copyright"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_interactivemap_blurb"
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": "virtual tour",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_name"
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d6d9d-49a5-7587-b84e-e2aedab919be.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "footer.powered_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d6d9d-fa1c-74bf-a89d-68fd979db7af.webp"
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/schedule-a-tour"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "footer.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_primary_logo"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_primary_logo_media.alt_text"
      }
    }
  },
  "manualfloorplans.plan_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02098-8e9e-704b-a3f3-312cc5800391.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A1 one-bedroom, one-bath floor plan layout, 673 square feet"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "A1"
      },
      "beds": {
        "type": "GENERATOR",
        "generatedValue": "1"
      },
      "baths": {
        "type": "GENERATOR",
        "generatedValue": "1"
      },
      "sqft": {
        "type": "GENERATOR",
        "generatedValue": "673"
      }
    }
  },
  "manualfloorplans.plan_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02098-b1ce-7314-b587-3565d1d60f0d.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A2 one-bedroom, one-bath floor plan layout, 800 square feet"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "A2"
      },
      "beds": {
        "type": "GENERATOR",
        "generatedValue": "1"
      },
      "baths": {
        "type": "GENERATOR",
        "generatedValue": "1"
      },
      "sqft": {
        "type": "GENERATOR",
        "generatedValue": "800"
      }
    }
  },
  "manualfloorplans.plan_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02098-8ea2-767d-a1d0-04f8d33fcc5c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "B1 two-bedroom, two-bath floor plan layout, 1,028 square feet"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "B1"
      },
      "beds": {
        "type": "GENERATOR",
        "generatedValue": "2"
      },
      "baths": {
        "type": "GENERATOR",
        "generatedValue": "2"
      },
      "sqft": {
        "type": "GENERATOR",
        "generatedValue": "1,028"
      }
    }
  },
  "manualfloorplans.plan_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167721/01a02098-c52a-741d-b71d-bf10d28293f1.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "B3 Terrace Level two-bedroom, two-bath floor plan layout, 1,428 square feet"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "B3 - Terrace Level"
      },
      "beds": {
        "type": "GENERATOR",
        "generatedValue": "2"
      },
      "baths": {
        "type": "GENERATOR",
        "generatedValue": "2"
      },
      "sqft": {
        "type": "GENERATOR",
        "generatedValue": "1,428"
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
